const SalesPage = () => {
    
    return (
        <div className="sales-page">
            <h1>THIS IS THE SALES PAGE</h1>

        </div>
    )
}

export default SalesPage